import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface KpiCardProps {
  /** Eyebrow label above the value. */
  label: string;
  /** The metric. Nullish or empty renders an em-dash placeholder. */
  value: ReactNode;
  /** Optional muted caption below the value. */
  caption?: string;
  /** Extra classes for the value line (e.g. a warning tone for non-zero denials). */
  valueClassName?: string;
}

/** Brand KPI tile: uppercase eyebrow, editorial weight-400 value, muted caption. */
export function KpiCard({ label, value, caption, valueClassName }: KpiCardProps) {
  const isEmpty = value == null || value === "";
  return (
    <div className="bg-card border-border rounded-lg border px-4 py-3 shadow-sm">
      <p className="text-muted text-[10px] font-medium tracking-[0.18em] uppercase">{label}</p>
      <p
        className={cn(
          "font-display text-foreground mt-1 text-2xl leading-none font-normal tracking-tight",
          valueClassName,
        )}
      >
        {isEmpty ? "—" : value}
      </p>
      {caption && <p className="text-muted mt-1 text-xs">{caption}</p>}
    </div>
  );
}
